import { render, staticRenderFns } from "./DialogTablePagination.vue?vue&type=template&id=8ec49742&lang=pug&"
import script from "./DialogTablePagination.vue?vue&type=script&lang=js&"
export * from "./DialogTablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports